/**
 * @generated SignedSource<<cdd282a046877f42e38226eb3da9e4c2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type productListConnectModelMutation$variables = {
  id: string;
  target: ModelDuplicateTargetInput;
};
export type productListConnectModelMutation$data = {
  readonly connectModel: string;
};
export type productListConnectModelMutation = {
  response: productListConnectModelMutation$data;
  variables: productListConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "target"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListConnectModelMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productListConnectModelMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "42ffe07e1388a053e6a190e8d5dc80bf",
    "id": null,
    "metadata": {},
    "name": "productListConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation productListConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n) {\n  connectModel(id: $id, target: $target)\n}\n"
  }
};
})();

(node as any).hash = "b177ebc3aeb25be679360d0334215efd";

export default node;
